import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { AppStore } from 'src/app/core';

@Component({
  selector: 'content-warning',
  templateUrl: './content-warning.component.html',
  styleUrls: ['./content-warning.component.scss'],
  standalone: false
})
export class ContentWarningComponent implements OnInit {
  @Output() close = new EventEmitter<any>();
  @Output() accept = new EventEmitter<any>();
  goClient = false;

  constructor(private appStore: AppStore) {}

  ngOnInit(): void {
    this.goClient = this.appStore.origin === 'personas';
  }

  cancel() {
    this.close.emit();
  }

  goAccept() {
    this.accept.emit();
  }
}
